import { ChangeEvent } from "react";
import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";

const {
  venueBlock: {
    search: { labelTitle },
  },
  errors,
} = copy;

export const getFields = ({
  handleTitleChange,
}: {
  handleTitleChange: (title: string | null) => void;
}): IFormFields => [
  {
    name: "title",
    label: labelTitle,
    type: IFieldType.text,
    onChange: (event: ChangeEvent<HTMLInputElement>) => {
      handleTitleChange(event.target.value || null);
    },
    validation: {
      required: errors.required,
    },
  },
];
